import { Component, Prop, Vue } from 'vue-property-decorator';
import { ProjectPeerEvaluationDetailDTO, UserEngagementDTO } from '@/models';
import Tooltip from '@/components/common/tooltip/Tooltip.vue';

@Component({
  components: {
    Tooltip
  }
})
export default class DropsBreakDown extends Vue {
  @Prop() projectPeerEvaluationDetail: ProjectPeerEvaluationDetailDTO;

  private isSelfProject = false;
  private statusPendingDisplay = 'pending...';
  private totalHoursContribution = 0;

  created(): void {
    this.isSelfProject = this.userEngagements.length === 1;
    this.calculateTotalHoursContribution();
  }

  calculateTotalHoursContribution(): void {
    this.totalHoursContribution = this.userEngagements.reduce((acc, curr) => acc + curr.contribution, 0);
  }

  get contribution(): string {
    const { contribution } = this.projectPeerEvaluationDetail.userEngagement;

    if (contribution) {
      return contribution.toString();
    }
    return this.statusPendingDisplay;
  }

  get contributionDrops(): string {
    const { contributionDrops } = this.projectPeerEvaluationDetail.userEngagement;

    if (contributionDrops) {
      return contributionDrops.toString();
    }
    return this.statusPendingDisplay;
  }

  get contributionPercent(): string {
    const contributionPercent = (
      (this.projectPeerEvaluationDetail.userEngagement.contribution / this.totalHoursContribution) *
      100
    ).toFixed(2);

    return this.projectPeerEvaluationDetail.userEngagement ? contributionPercent + ' %' : this.statusPendingDisplay;
  }

  get finalDrops(): string {
    const { contributionDrops, givingDrops } = this.projectPeerEvaluationDetail.userEngagement;

    if (this.isSelfProject) {
      return contributionDrops.toString();
    }
    if (contributionDrops >= 0 && +this.totalReceivedDrops >= 0 && givingDrops) {
      return (contributionDrops + +this.totalReceivedDrops - givingDrops).toString();
    }
    return this.statusPendingDisplay;
  }

  get givingDrops(): string {
    const { givingDrops } = this.projectPeerEvaluationDetail.userEngagement;

    if (givingDrops) {
      return givingDrops.toString();
    }
    if (this.isSelfProject) {
      return '0';
    }
    return this.statusPendingDisplay;
  }

  get totalReceivedDrops(): string {
    const { adjustedDrops } = this.projectPeerEvaluationDetail.userEngagement;
    const totalReceivedDrops = this.projectPeerEvaluationDetail.peerEvaluations.reduce(
      (acc, curr) => acc + curr.givingDrops,
      0
    );

    if (this.isSelfProject) {
      return '0';
    }
    if (adjustedDrops !== null) {
      return adjustedDrops.toString();
    }
    if (adjustedDrops === null && totalReceivedDrops === 0) {
      return this.statusPendingDisplay;
    }
    return totalReceivedDrops.toString();
  }

  get userEngagements(): UserEngagementDTO[] {
    return this.$store.getters['project/userEngagements'];
  }
}
